NtechApp.CreateTeamForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._form = null;
    this._isSaving = false;

    this._construct = function () {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._form = new NtechApp.ModalForm();

        me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.CreateTeamForm.EVENT_PINCODE_CREATED = "NtechApp.CreateTeamForm.EventPinCodeCreated";

NtechApp.proto(NtechApp.CreateTeamForm, {
    loadForm: function() {
        var me = this;

        this._form.load("business_dashboard_load_create_team_form", function($form) {
            me._click.listen($form.find("[data-closeBut]"), function(e) {
                me.unloadForm();
            });

            me._click.listen($form.find("[data-confirmBut]"), function(e) {
                if(me._isSaving) return;
                me._isSaving = true;

                var $control = $(e.target).closest("[data-confirmBut]");
                me._createTeam($form, $control);
            });

            $form.find("#pinCode").on("input", function() {
                var val = $(this).val();
                if(val.length > 4) {
                    val = val.slice(0, 4);
                    $(this).val(val);
                }
            });
        });
    },

    unloadForm: function() {
        this._form.unload();
    },

    _createTeam: function($form, $control) {
        var me = this;
        var origText = $control.text();

        $control.text("");
        me._ajax.enableTextLoading($control);

        this._ajax.post({
            url: Routing.generate('business_dashboard_save_create_team_form'),
            data: {
                pinCode: $form.find("#pinCode").val(),
                createTeam: {
                    _token: $form.find("#create_team__token").val()
                }
            },
            onSuccess: function(res) {
                me.unloadForm();
                $(me).trigger(NtechApp.CreateTeamForm.EVENT_PINCODE_CREATED);

                NtechApp.info.on("Your team has been successfully created!", 2500);
            },
            onError: function(errors) {
                var errs = "";
                for(err in errors)
                    errs += errors[err];

                NtechApp.info.on(errs, 2500);
            },
            onComplete: function() {
                me._ajax.disableTextLoading($control);
                me._isSaving = false;

                $control.text(origText);
            }
        });
    }
});